import React from 'react'
import { useDispatch } from 'react-redux'
import { Alert as AlertComponent } from '@babylon/medkit'
import { CloseCircleFilled, InfoFilled, TickCircleFilled } from '@babylon/icons'

import { reset } from '@/redux/appMessage/actions'
import { useAppMessage } from '@/redux/appMessage/selectors'
import styles from './Alert.module.scss'

// Time that the flash message will be active for, in ms
const RESET_FLASH_TIMER = 8000

const feedbackIcons = {
  positive: <TickCircleFilled />,
  negative: <CloseCircleFilled />,
  default: <InfoFilled />,
}

// TODO: introduce message queues
const Alert = () => {
  const alert = useAppMessage()
  const dispatch = useDispatch()

  if (alert?.text) {
    setTimeout(() => {
      dispatch(reset())
    }, RESET_FLASH_TIMER)
  } else {
    return null
  }

  const { text, style } = alert
  const iconType = style as keyof typeof feedbackIcons

  const Icon = feedbackIcons[iconType] || feedbackIcons.default

  return (
    <div className={styles.appMessage}>
      <AlertComponent
        icon={Icon}
        type={alert.style}
        data-testid="formFeedbackAlert"
        data-e2e-feedback-type={alert.style}
      >
        {text}
      </AlertComponent>
    </div>
  )
}

export default Alert
